import React, { useState , useEffect} from 'react'
import { Link } from 'react-router-dom';
import { Scroll } from '../../components/Scroll function/scroll'
import "./Pagination.css"

const LEFT_PAGE = 'LEFT';
const RIGHT_PAGE = 'RIGHT';

const range = (fromNum, to, step = 1) => {
    let i = fromNum;
    const range = [];

    while (i <= to) {
        range.push(i);
        i += step;
    }
    return range;
}


const Pagination = ({ totalRecords, pageLimit = 50, pageNeighbours = 1, onPageChanged, currentPage = 1, setCurrentPage }) => {
    // console.log(onPageChanged,'iamgine pacakges jsssss')
    // console.log(setCurrentPage,'iamgine pacakges set current pageeee jsssss')
    // console.log(pageLimit,'iamgine pacakges limit jsssss')
//     useEffect(() => {
//         Scroll()
//  }, [])

    pageLimit = typeof pageLimit === 'number' ? pageLimit : 50
    totalRecords = typeof totalRecords === 'number' ? totalRecords : 0
    pageNeighbours = typeof pageNeighbours === 'number' ? Math.max(0, Math.min(pageNeighbours, 2)) : 0
    let totalPages = Math.ceil(totalRecords / pageLimit);

    console.log(pageLimit,totalRecords,pageNeighbours,"amgine pacakges")

    const fetchPageNumbers = () => {
        const totalNumbers = (pageNeighbours * 2) + 3;
        const totalBlocks = totalNumbers + 2;
        if (totalPages > totalBlocks) {
            const startPage = Math.max(2, currentPage - pageNeighbours);
            const endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);
            let pages = range(startPage, endPage);

            const hasLeftSpill = startPage > 2;
            const hasRightSpill = (totalPages - endPage) > 1;
            const spillOffset = totalNumbers - (pages.length + 1);

            switch (true) {
                case (hasLeftSpill && !hasRightSpill): {
                    const extraPages = range(startPage - spillOffset, startPage - 1);
                    pages = [LEFT_PAGE, ...extraPages, ...pages];
                    break;
                }
                case (!hasLeftSpill && hasRightSpill): {
                    const extraPages = range(endPage + 1, endPage + spillOffset);
                    pages = [...pages, ...extraPages, RIGHT_PAGE];
                    break;
                }
                case (!hasLeftSpill && !hasRightSpill): {
                    break;
                }
                default: {
                    pages = [LEFT_PAGE, ...pages, RIGHT_PAGE];
                    break;
                }
            }
            return [1, ...pages, totalPages];
        }
        return range(1, totalPages);
    }

    const gotoPage = page => {
        const pageToMove = Math.max(0, Math.min(page, totalPages));
        setCurrentPage(pageToMove)
        const paginationData = {
            currentPage: pageToMove,
            totalPages: totalPages,
            pageLimit: pageLimit,
            totalRecords: totalRecords
        };
        onPageChanged(paginationData)
    }

    const handleClick = (page) => {
        gotoPage(page);
        Scroll();
    }

    const handleMoveLeft = () => {
        // gotoPage(currentPage - (pageNeighbours * 2) - 1);
        gotoPage(currentPage - pageNeighbours);

    }

    const handleMoveRight = () => {
        // gotoPage(currentPage + (pageNeighbours * 2) + 1);
        gotoPage(currentPage + pageNeighbours);
    }

    let pages = fetchPageNumbers()

    return (
        <React.Fragment>
            <div className="Pagination-page">
            <nav aria-label="Pagination">
                <ul className="pagination">
                    {pages.map((page, index) => {
                        if (page === LEFT_PAGE) return (
                            <li key={index} className="page-item">
                                <Link className="page-link" to="#" aria-label="Previous" onClick={() => handleMoveLeft()}>
                                    <span aria-hidden="true">&laquo;</span>
                                    <span className="sr-only">Previous</span>
                                </Link>
                            </li>
                        );
                        if (page === RIGHT_PAGE) return (
                            <li key={index} className="page-item">
                                <Link className="page-link" to="#" aria-label="Next" onClick={() => handleMoveRight()}>
                                    <span aria-hidden="true">&raquo;</span>
                                    <span className="sr-only">Next</span>
                                </Link>
                            </li>
                        );
                        return (
                            <li key={index} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                                <Link className="page-link" to="#" onClick={(e) => handleClick(page)}>
                                    {page}
                                </Link>
                            </li>
                        );
                    })}
                </ul>
            </nav>
            </div>
        </React.Fragment>
    )
}

export default Pagination